module.exports = __webpack_public_path__ + "images/Wide Image 2.png";